import { Statistic } from "antd";
import "./assetsOverview.less";

interface IProps {
    chainsNumber: number;
    bridgesNumber: number;
    tokensNumber: number;
}

const AssetsOverview = (props: IProps) => {

    return (
        <div className="assets-content-dataview">
            <div className="dataview-item">
                <Statistic title="Supported Chains" value={props.chainsNumber} />
            </div>
            <div className="dataview-item">
                <Statistic title="Supported Tokens" value={props.tokensNumber} />
            </div>
            <div className="dataview-item">
                <Statistic title="Supported Bridges" value={props.bridgesNumber} />
            </div>
        </div>
    )
}

export default AssetsOverview;